import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../ConsolidationExportUIHelpers";

import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { toMonthName } from "../../../../../config/helper";

// ? LIBRARY TABLE PAGINATION FOR FOLDER WITHOUT PARENT UUID
const ConsolidationExportTable = ({
  entities,
  totalCount,
  listLoading,
  queryParams = {},
  setQueryParams
}) => {
  // Table columns
  const columns = [
    {
      dataField: "organization.name",
      text: "Lembaga",
      sort: true
    },
    {
      dataField: "year",
      text: "Tahun",
      sort: true
    },
    {
      dataField: "month",
      text: "Bulan",
      sort: true,
      formatter: cell => {
        return toMonthName(cell);
      }
    },
    {
      dataField: "zakat",
      text: "Zakat",
      sort: true,
      formatter: cell => {
        return currencyFormatter(cell);
      }
    },
    {
      dataField: "infaq",
      text: "Infak",
      sort: true,
      formatter: cell => {
        return currencyFormatter(cell);
      }
    },
    {
      dataField: "alms",
      text: "Sedekah",
      sort: true,
      formatter: cell => {
        return currencyFormatter(cell);
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default ConsolidationExportTable;
